import { render, staticRenderFns } from "./VacancyRole.htm?vue&type=template&id=42b8a956&scoped=true&"
import script from "./VacancyRole.ts?vue&type=script&lang=js&"
export * from "./VacancyRole.ts?vue&type=script&lang=js&"
import style0 from "./VacancyRole.scss?vue&type=style&index=0&id=42b8a956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8a956",
  null
  
)

export default component.exports